export default __webpack_public_path__ + "static/media/Ballroll_00292.2fffd2c9.png";